import { EngageTimeSeries, EngageTimeSeriesType } from '@/types/engage.types';
import { convertConfigToTimeSeries } from '@/common/time-series-picker/time-series-picker.util';
import { RouterQuery } from './router-query-filters';

export type DashboardDateRange = { timeSeries: EngageTimeSeries };

export type DateRangeTypeQueryValue = 'today' | 'yesterday' | '7' | '30' | '90' | '180' | 'custom';

const dateTypeParamMap: Map<EngageTimeSeriesType, DateRangeTypeQueryValue> = new Map([
    ['Today', 'today'],
    ['Yesterday', 'yesterday'],
    ['Last 7 Days', '7'],
    ['Last 30 Days', '30'],
    ['Last 90 Days', '90'],
    ['Last 180 Days', '180'],
    ['Custom', 'custom'],
]);

const reverseDateTypeParamMap: Map<DateRangeTypeQueryValue, EngageTimeSeriesType> = new Map(
    Array.from(dateTypeParamMap).map(([key, val]) => [val, key]),
);

export function formatDateRangeForQuery ({ timeSeries }: DashboardDateRange) {
    const { start, end, type } = timeSeries.config;
    const typeValue = dateTypeParamMap.get(type);

    if (typeValue && typeValue !== 'custom') {
        return { dateType: typeValue };
    }

    return { start, end };
}

const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

// https://stackoverflow.com/questions/18758772/how-do-i-validate-a-date-in-this-format-yyyy-mm-dd-using-jquery
/**
 * returns true if passed value is valid date formatted as YYYY-MM-DD string
 */
export function isValidDateString (value: unknown): boolean {
    if (!(typeof value === 'string' && dateRegex.test(value))) return false;

    const valDate = new Date(value);
    const dNum = valDate.getTime();
    if (!dNum && dNum !== 0) return false;

    return valDate.toISOString().slice(0, 10) === value;
}

export function convertQueryToDateRange ({ dateType, start, end }: RouterQuery) {
    let timeSeries;
    const type = dateType && reverseDateTypeParamMap.get(dateType);
    if (type && type !== 'Custom') {
        timeSeries = convertConfigToTimeSeries({ type });
    } else if (start && end) {
        if ([start, end].every(isValidDateString)) {
            timeSeries = convertConfigToTimeSeries({ type: 'Custom', start, end });
        }
    }

    return timeSeries ? { dateRange: { timeSeries: timeSeries as EngageTimeSeries } } : {};
}

export const getDefaultDateRange = (): DashboardDateRange => ({
    timeSeries: convertConfigToTimeSeries({ type: 'Last 30 Days' }) as EngageTimeSeries,
});
